import Mutations from '../../odata/mutations';

export default { ...new Mutations('tax'), ...new Mutations('taxes') };
